import ButtonCount from '../../../components/ButtonCount';

import { usePallet } from '../../../contexts/PalletContext';


export interface IFiltroNotificacaoProps {
    key: string,
    type?: string;
    label: string,
    total: number,
    active: boolean,
};


export function NotificacoesList(props: {
    filtros: IFiltroNotificacaoProps[],
    onChange: (event: any) => void,
    desligaLoading?: React.Dispatch<React.SetStateAction<boolean>>,
    loading?: boolean,
    desligaLoadingClickAba?: number
    liberar?: boolean
}): JSX.Element {
    const { pallet } = usePallet();
    return (
        <>
            {props.filtros?.map((item) => {
                return (
                    <>
                        <ButtonCount
                            desligaLoading={props.desligaLoading}
                            desligaLoadingClickAba={props.desligaLoadingClickAba}
                            loading={props.loading}
                            item={item}
                            liberar={props.liberar}
                            active={item.active}
                            onClick={(e) => props.onChange(e)}
                            style={{
                                backgroundColor: `${item.active ? pallet.textColorQuintenary : "#FFFFFF"}`,
                                //flexDirection: "row-reverse",
                                //justifyContent: "space-between"    
                            }}
                        />

                    </>
                )
            })}
        </>
    );
};

export default NotificacoesList;
